import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../../ReactQuery/useQuery';
import { get } from '../../../../redux/api';
import type {
  ListOrganizationDeletionsRequest,
  ListOrganizationDeletionsResponse,
} from '../../../../../shared/types/routes/internalTools/orgDeletion';

/** Shared by the list and every org deletion mutation, which invalidate it on success. */
export const ORG_DELETIONS_QUERY_KEY: QueryKey = ['internal-tools', 'organization-deletions'];

export const getOrgDeletionsQueryKey = (params: ListOrganizationDeletionsRequest): QueryKey =>
  [...ORG_DELETIONS_QUERY_KEY, params];

function getOrgDeletions(params: ListOrganizationDeletionsRequest) {
  // Encoded, so characters like + and & in the filters reach the server unchanged (e.g. ron+cs@fossa.com).
  return get<ListOrganizationDeletionsResponse>('/api/internal-tools/organization-deletions', false, params, {
    encodeQuery: true,
  });
}

/**
 * Fetches a page of org deletions, newest scheduled first, filtered by organization, status, requester email
 * or a search of the organization id and title.
 *
 * @param {ListOrganizationDeletionsRequest} params - The filters and page.
 * @param {boolean} enabled - Whether to run the query. Pass `false` while the org deletion flag is off.
 */
export function useGetOrgDeletions(params: ListOrganizationDeletionsRequest, enabled: boolean) {
  return useQuery<ListOrganizationDeletionsResponse>({
    queryKey: getOrgDeletionsQueryKey(params),
    queryFn: () => getOrgDeletions(params),
    enabled,
  });
}
